export abstract class Query {}
